



































































import IPassengerPhoneNumberViewModel from '../models/IPassengerPhoneNumberViewModel';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
@Component({
    components: {

    }
}
)
export default class PassengerPhonenumberEditor extends Vue {
 
phoneNumbers: IPassengerPhoneNumberViewModel[] = [];
panel: any[] = [];

created() {
  // Initialize panel array. null for each phonenumber. 
  // So when we create new phonenumber we can open expasion for it.
  this.phoneNumbers.forEach(p => {
    this.panel.push(null);
  })
}

@Prop({ default: [] }) private value!: IPassengerPhoneNumberViewModel[]; 
@Prop({ default: false }) private allowUserInput!: boolean;
@Prop({ default: false }) private shouldSave!: boolean;

@Watch('value', { immediate: true })valueChanged() {
  this.phoneNumbers = JSON.parse(JSON.stringify(this.value));
}

// get showNewPhoneNumberButton() {
//   return this.phoneNumbers.every(p => p.id !== 0) || this.phoneNumbers.length === 0
// }

update() {
  this.$emit('input', this.phoneNumbers);
}

closeDropDown(index: number) {
  const phoneNumber = this.phoneNumbers[index];
  if (!phoneNumber.number) {
    this.phoneNumbers.splice(index, 1);
    this.update();
  } else {
    this.$set(this.panel, index, null)
  }
}

addPhoneNumber() {
  const newPhoneNumber: IPassengerPhoneNumberViewModel = {
    id: 0,
    passengerId: 0,
    number: '',
    sms: true,
    showToDriver: true,
    assistant: false,
  }

  this.phoneNumbers.push(newPhoneNumber);
  // This has to be done so expansion opens for new phoneNumber
  this.panel.push(true);
  this.$emit('input', this.phoneNumbers);
}

removePhoneNumber(phoneNumber: IPassengerPhoneNumberViewModel) {
  const index = this.phoneNumbers.indexOf(phoneNumber);
  this.phoneNumbers.splice(index, 1);
  this.update();
}

}
